/* src/app/workshop/components/assets/view-assets/view-assets.component.scss */
/*# sourceMappingURL=view-assets.component.css.map */
